import axios from '@/libs/api.request'
import qs from 'qs'

// 拣货员登录
export const sortingLogin = (data) => {
  return axios.request({
    url: '/api/v1/users/sortingLogin',
    data,
    method: 'post'
  })
};

// 根据code获取token
export const getTokenByCode = (code) => {
  let data = qs.stringify({
    authorization: code.authorization,
    client_id: code.client_id,
    redirect_uri: code.redirect_uri,
    client_secret: 'admin'
  })
  return axios.request({
    url: '/api/v1/users/getToken',
    data,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': code.authorization
    }
  })
};

// 获取用户信息
export const getUserInfo = (data) => {
  return axios.request({
    url: '/api/v1/users/getUserInfo',
    params: data,
    method: 'get',
  })
};

// 获取供应商列表
export const querySupplierList = data => {
  return axios.request({
    url: "/api/v1/users/querySupplierList",
    data,
    method: "post"
  });
};

// 获取供应商列表
export const logout = data => {
  return axios.request({
    url: "/api/v1/users/logout",
    data,
    method: "post"
  });
};



// WEBPACK FOOTER //
// ./src/api/user/user.js